import {Injectable} from "@angular/core";
import {HttpClient, HttpHandler} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {RedirectRequest} from "../../interfaces/master-pass/RedirectRequest";

@Injectable()
export class MasterPassApi extends HttpClient {

  private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/master/pass' : environment.baseUrl + '/master/pass';
  private callBackBaseUrl = environment.baseUrlCallback + "/callback/master/pass";

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initializeQRCode(sessionToken : string) {
    const url = `${this.baseUrl}/qrcode/${sessionToken}` ;
    return super.post(url, null);
  }

  public redirectMasterPass(sessionToken: string, redirectRequest: RedirectRequest) {
    const url = `${this.callBackBaseUrl}/redirect/${sessionToken}`;
    return super.post(url, redirectRequest);
  }

  public validateMasterPass(sessionToken: string): Observable<any> {
    const url = `${this.baseUrl}/validate/${sessionToken}`;
    return super.get(url);
  }

}
